










import {Vue as VueComponent, Component, Mixins} from "vue-property-decorator";
import InvitesList from "../../share/invites/InvitesList.vue";
import AnalyticsMixin from "../../mixins/AnalyticsMixin";
import { isRouteMeetings } from "@service/router/helpers/commonRoutesHelper";

@Component({
    name: 'Invites',
    components: { InvitesList }
})
export default class Invites extends Mixins(AnalyticsMixin) {
    activated() {
        this.sendScreenView('Invites list');
    }

    get eventId() {
        return this.$store.state.events.selected;
    }

    get key() {
        return 'invites_' + this.eventId;
    }

    newMeeting({time, date}: any) {
        const query: any = {};
        if (time) {
            query['time'] = time as string;
        }
        if (date) {
            query['date'] = date as string;
        }

        this.$router.push({
            name: 'CreateMeeting',
            params: {backend: this.$route.params.backend},
            query
        });
    }

    get meetingId() {
        if (isRouteMeetings(this.$route.name || '')) {
            return this.$route.params.id;
        }
        return '';
    }
}
